import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import classNames from 'classnames/bind';
import React, { useRef, Fragment } from 'react';
import { useClickAway } from 'react-use';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import IcClose from '../icons/IcClose.js';
import COLOR from '../../foundation/color.js';
import useTooltip from '../../hooks/useTooltip.js';
import style from './Tooltip.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
function TooltipButton(_ref) {
  var children = _ref.children,
    tooltip = _ref.tooltip,
    showUnderline = _ref.showUnderline;
  var _useTooltip = useTooltip(),
    showTooltip = _useTooltip.showTooltip,
    handleTooltip = _useTooltip.handleTooltip,
    $tooltipButton = _useTooltip.$tooltipButton;
  var contents = tooltip.contents,
    position = tooltip.position,
    articleClassName = tooltip.articleClassName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button', {
      'type-text': showUnderline
    }),
    onClick: handleTooltip,
    ref: $tooltipButton
  }, children, /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD234\uD301 \uBCF4\uAE30")), showTooltip ? ( /*#__PURE__*/React.createElement(Tooltip, {
    isShow: showTooltip,
    tooltipButtonRef: $tooltipButton,
    onHideTooltip: handleTooltip,
    position: position,
    contents: contents,
    articleClassName: articleClassName
  })) : null);
}
function Tooltip(_ref2) {
  var _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'top' : _ref2$position,
    _ref2$contents = _ref2.contents,
    contents = _ref2$contents === void 0 ? [] : _ref2$contents,
    isShow = _ref2.isShow,
    onHideTooltip = _ref2.onHideTooltip,
    tooltipButtonRef = _ref2.tooltipButtonRef,
    articleClassName = _ref2.articleClassName;
  var tooltipRef = useRef(null);
  var handleTooltip = function handleTooltip(e) {
    var _tooltipButtonRef$cur;
    if (tooltipButtonRef !== null && tooltipButtonRef !== void 0 && (_tooltipButtonRef$cur = tooltipButtonRef.current) !== null && _tooltipButtonRef$cur !== void 0 && _tooltipButtonRef$cur.contains(e.target)) {
      return;
    }
    if (isShow) {
      e.stopPropagation();
      onHideTooltip(e);
    }
  };
  useClickAway(tooltipRef, function (e) {
    return handleTooltip(e);
  }, ['mousedown']);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', "position-".concat(position), articleClassName),
    ref: tooltipRef
  }, contents === null || contents === void 0 ? void 0 : _mapInstanceProperty(contents).call(contents, function (_ref3, index) {
    var title = _ref3.title,
      description = _ref3.description;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "tooltip-".concat(index)
    }, /*#__PURE__*/React.createElement("strong", {
      className: cx('title')
    }, title), /*#__PURE__*/React.createElement("div", {
      className: cx('description')
    }, description));
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onHideTooltip
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 20,
    height: 20,
    fill: COLOR.gray600.color
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD234\uD301\uB2EB\uAE30")));
}
Tooltip.Button = TooltipButton;

export { Tooltip as default };
